import type { TimelineOccurrence } from '../types/timeline';
import type { useWorkspaceStore } from '../stores/workspace';
import { type Ref } from 'vue';
import { storeToRefs } from 'pinia';


export function useChapterSceneActions(options: {
  store: ReturnType<typeof useWorkspaceStore>;
  isVersionReadonly: Readonly<Ref<boolean>>;
}) {
  const { store, isVersionReadonly } = options;
  const { activeEntity, timelineOccurrences } = storeToRefs(store);
async function reorderSceneTimeline(sceneIds: string[], storyline: string, chapterId = '') {
  if (isVersionReadonly.value) return;
  try { await store.reorderSceneTimeline(sceneIds, storyline, chapterId); }
  catch (reason) { store.error = reason instanceof Error ? reason.message : 'Die Szenenreihenfolge konnte nicht gespeichert werden.'; }
}

async function reorderChapterScenes(updates: Array<{ sceneIds: string[]; storyline: string }>) {
  if (!activeEntity.value || isVersionReadonly.value) return;
  try {
    for (const update of updates) await store.reorderSceneTimeline(update.sceneIds, update.storyline, activeEntity.value.id);
  } catch (reason) { store.error = reason instanceof Error ? reason.message : 'Die Szenenreihenfolge konnte nicht gespeichert werden.'; }
}
async function changeChapterSceneStoryline(sceneId: string, storyline: string) {
  if (!activeEntity.value || isVersionReadonly.value) return;
  try { await store.setSceneStoryline(sceneId, storyline, activeEntity.value.id); }
  catch (reason) { store.error = reason instanceof Error ? reason.message : 'Der Handlungsstrang konnte nicht gespeichert werden.'; }
}
async function updateChapterScene(sceneId: string, patch: { title?: string; summary?: string | null; fieldValues?: Record<string, unknown> }) {
  if (isVersionReadonly.value) throw new Error('Diese Version ist schreibgeschützt.');
  try { await store.updateSceneFromChapter(sceneId, patch); }
  catch (reason) {
    store.error = reason instanceof Error ? reason.message : 'Die Szene konnte nicht gespeichert werden.';
    throw reason;
  }
}
async function changeChapterSceneNarrativeRelation(sceneId: string, relation: TimelineOccurrence['narrativeRelation']) {
  if (isVersionReadonly.value) return;
  try {
    const current = timelineOccurrences.value.find((item) => item.entityId === sceneId);
    if (current) await store.updateTimelineOccurrence(current.id, { narrativeRelation: relation });
    else await store.saveTimelineOccurrence(sceneId, {
      eraEntityId: null, inUniverseStart: null, inUniverseEnd: null, sortKey: 0, narrativePosition: null,
      precision: 'exact', isUncertain: false, notes: null, timeSource: 'inherit', narrativeRelation: relation
    });
  } catch (reason) { store.error = reason instanceof Error ? reason.message : 'Die Erzählzeit konnte nicht gespeichert werden.'; }
}
async function deleteChapterScene(id: string, title: string) {
  if (isVersionReadonly.value) return;
  if (!confirm(`„${title}“ archivieren? Verweise bleiben als gelöschte Ghost-Referenzen sichtbar.`)) return;
  try { await store.archiveEntity(id); }
  catch (cause) { store.error = cause instanceof Error ? cause.message : 'Szene konnte nicht archiviert werden.'; }
}
  return { reorderSceneTimeline, reorderChapterScenes, changeChapterSceneStoryline, updateChapterScene, changeChapterSceneNarrativeRelation, deleteChapterScene };
}
